import React from "react";
import "./HomeSec5.css";

const HomeSec5 = () => {
  return (
    <div className="main5-container">
      <div className="container-fluid main5">
        <div className="col-12 d-flex py-sm-5"></div>
        <div className="row d-flex   justify-content-center align-items-center pb-5">
          {/* <div className="col-3"></div> */}
          <div className="d-flex flex-column  justify-content-center align-items-center  ">
            <span className="p-15">WEDDING FESTIVITIES</span>
            <img className="img_115" src="./image434.webp" alt="hhh" />
          </div>
          {/* <div className="col-3"></div> */}
        </div>
      </div>
      <div className="container-fluid main15">
        <div className="cont-55 ">
          <div className="cont-cc  ">
            <img className="img-15" src="./img.webp" alt="hhh" />
            <img className="img-25" src="./image 428.webp" alt="hhh" />
          </div>
          <div className="cont-ccc">
            <div className=" ">
              <div className="d-flex flex-column  justify-content-center ">
                <span className="para-5">HALDI</span>
                <img className="img-35" src="./image434.webp" alt="hhh" />
              </div>
              <p className="para-25">
                Exploring the lush green gardens of Surya Vilas Palace is a
                journey into natural splendor and historical enchantment.
                Strolling along manicured pathways adorned with vibrant flora,
                one is transported to a bygone era of aristocratic elegance.
                Towering trees whisper tales of centuries past, while fragrant
                blooms perfume the air with their delicate scent. Secluded
                alcoves and hidden nooks invite moments of quiet contemplation
                amidst the verdant beauty. The harmonious blend of heritage
                architecture and lush landscapes creates a picturesque setting,
                where time seems to stand still. Each step is a discovery, each
                corner a new vista, offering a rejuvenating escape into the
                embrace of nature's bounty.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSec5;
